import React, { useState } from "react";
import Modal from "react-modal";
import ModalContent from "./ModalContent";
import RightAbout from './RigthAbout'

Modal.setAppElement("#root");

const About = () => {
  const [isOpen, setIsOpen] = useState(false);

  function toggleModal() {
    setIsOpen(!isOpen);
  }

  return (
    <>
      <div className="tokyo_tm_about">

        <div className="about_image">
          <img src="assets/img/slider/full.png" alt="about" />
        </div>

        {/* END ABOUT IMAGE */}
        <div className="description">

          <h3 className="name">Oscar Javier Villanueva Prieto</h3>

          <div className="description_inner">

            <div className="left">

              <p>

                Hello, I am a fronted developer based in México and happy
                to develop solutions to all kind of people, improving the way they connect, share and interact, bringing a new way to communicate

              </p>

              <div className="tokyo_tm_button">
                <button onClick={toggleModal} className="ib-button">

                  Read More

                </button>
              </div>

            </div>


            <RightAbout />
            
          </div>
          
        </div>

      </div>

      <Modal
        isOpen={isOpen}
        onRequestClose={toggleModal}
        contentLabel="My dialog"
        className="mymodal"
        overlayClassName="myoverlay"
        closeTimeoutMS={500}
      >
        
        <ModalContent 
          toggleModal = { toggleModal }
        />

      </Modal>
    </>
  );
};

export default About;
